<!--
  Vue wrapper for Bryntum Scheduler
-->

<template>
    <div>
        <!-- Container for Vue components used in cells, hidden from view -->
        <div
            ref   = "cellInstancesHolder"
            style = "display: none"
        >
            <component
                :is    = "component.is"
                v-for  = "component in cellInstances"
                :ref   = "component.key"
                :key   = "component.key"
                v-bind = "component"
            />
        </div>
    </div>
</template>

<script>

import { AssignmentModel, AssignmentStore, Base, CrudManager, DependencyModel, DependencyStore, EventModel, EventStore, Layout, Mask, Model, PresetStore, ProjectModel, Rectangle, ResourceModel, ResourceStore, ResourceTimeRangeModel, ResourceTimeRangeStore, Scheduler, ScrollManager, Scroller, Store, TimeAxis, TimeSpan, TimelineBase, ViewPreset, Widget } from '@bryntum/scheduler';

import { StringHelper } from '@bryntum/scheduler';
import WrapperHelper from './WrapperHelper.js';
import WrapperHelperVue2 from './WrapperHelperVue2.js';

export default {

    name : 'BryntumScheduler',

    props : {

         // Configs only
        adopt                            : { type : [HTMLElement, String], default : undefined },
        align                            : { type : [Object, String], default : undefined },
        allowCreate                      : { type : Boolean, default : undefined },
        allowOver                        : { type : Boolean, default : undefined },
        allowOverlap                     : { type : Boolean, default : undefined },
        anchor                           : { type : Boolean, default : undefined },
        anchorToTarget                   : { type : Boolean, default : undefined },
        animateRemovingRows              : { type : Boolean, default : undefined },
        appendTo                         : { type : [HTMLElement, String], default : undefined },
        autoAdjustTimeAxis               : { type : Boolean, default : undefined },
        autoClose                        : { type : Boolean, default : undefined },
        autoHeight                       : { type : Boolean, default : undefined },
        autoShow                         : { type : Boolean, default : undefined },
        bbar                             : { type : [Array, Object], default : undefined },
        bodyCls                          : { type : [String, Object], default : undefined },
        bubbleEvents                     : { type : Object, default : undefined },
        bufferCoef                       : { type : Number, default : undefined },
        bufferThreshold                  : { type : Number, default : undefined },
        centered                         : { type : Boolean, default : undefined },
        closable                         : { type : Boolean, default : undefined },
        closeAction                      : { type : String, default : undefined },
        cls                              : { type : [String, Object], default : undefined },
        columns                          : { type : [Array, Object], default : undefined },
        config                           : { type : Object, default : undefined },
        constrainTo                      : { type : [HTMLElement, Widget, Rectangle], default : undefined },
        contentElementCls                : { type : [String, Object], default : undefined },
        contextMenuTriggerEvent          : { type : String, default : undefined },
        createEventOnDblClick            : { type : [Boolean, Object], default : undefined },
        creationTooltip                  : { type : Object, default : undefined },
        crudManagerClass                 : { type : CrudManager, default : undefined },
        date                             : { type : Date, default : undefined },
        defaultBindProperty              : { type : String, default : undefined },
        defaultRegion                    : { type : String, default : undefined },
        defaultResourceImageName         : { type : String, default : undefined },
        defaults                         : { type : Object, default : undefined },
        descriptionRenderer              : { type : Function, default : undefined },
        destroyStore                     : { type : Boolean, default : undefined },
        destroyStores                    : { type : Boolean, default : undefined },
        disableGridRowModelWarning       : { type : Boolean, default : undefined },
        dismissDelay                     : { type : Number, default : undefined },
        dock                             : { type : String, default : undefined },
        draggable                        : { type : [Boolean, Object], default : undefined },
        durationDisplayPrecision         : { type : [Number, Boolean], default : undefined },
        emptyText                        : { type : String, default : undefined },
        enableDeleteKey                  : { type : Boolean, default : undefined },
        enableEventAnimations            : { type : Boolean, default : undefined },
        enableRecurringEvents            : { type : Boolean, default : undefined },
        enableSticky                     : { type : Boolean, default : undefined },
        enableTextSelection              : { type : Boolean, default : undefined },
        enableUndoRedoKeys               : { type : Boolean, default : undefined },
        endParamName                     : { type : String, default : undefined },
        eventBarTextField                : { type : String, default : undefined },
        eventBodyTemplate                : { type : Function, default : undefined },
        eventColor                       : { type : String, default : undefined },
        eventRenderer                    : { type : Function, default : undefined },
        eventRendererThisObj             : { type : Object, default : undefined },
        eventSelectionDisabled           : { type : Boolean, default : undefined },
        eventStyle                       : { type : String, default : undefined },
        features                         : { type : Object, default : undefined },
        fillLastColumn                   : { type : Boolean, default : undefined },
        fixedRowHeight                   : { type : Boolean, default : undefined },
        floating                         : { type : Boolean, default : undefined },
        focusOnToFront                   : { type : Boolean, default : undefined },
        footer                           : { type : [Object, String], default : undefined },
        forceFit                         : { type : Boolean, default : undefined },
        forElement                       : { type : HTMLElement, default : undefined },
        forSelector                      : { type : String, default : undefined },
        fullRowRefresh                   : { type : Boolean, default : undefined },
        getDateConstraints               : { type : Function, default : undefined },
        getHtml                          : { type : Function, default : undefined },
        getRowHeight                     : { type : Function, default : undefined },
        header                           : { type : [String, Object], default : undefined },
        hideAnimation                    : { type : [Boolean, Object], default : undefined },
        hideDelay                        : { type : Number, default : undefined },
        hideHeaders                      : { type : Boolean, default : undefined },
        hideOnDelegateChange             : { type : Boolean, default : undefined },
        hideWhenEmpty                    : { type : Boolean, default : undefined },
        highlightPredecessors            : { type : Boolean, default : undefined },
        highlightSuccessors              : { type : Boolean, default : undefined },
        horizontalEventSorterFn          : { type : Function, default : undefined },
        hoverDelay                       : { type : Number, default : undefined },
        htmlCls                          : { type : [String, Object], default : undefined },
        infiniteScroll                   : { type : Boolean, default : undefined },
        insertBefore                     : { type : [HTMLElement, String], default : undefined },
        insertFirst                      : { type : [HTMLElement, String], default : undefined },
        itemCls                          : { type : String, default : undefined },
        lazyItems                        : { type : [Object, Array], default : undefined },
        listeners                        : { type : Object, default : undefined },
        loadingMsg                       : { type : String, default : undefined },
        loadMask                         : { type : [String, Object, null], default : undefined },
        loadMaskDefaults                 : { type : [Object, Mask], default : undefined },
        loadMaskError                    : { type : [Object, Mask], default : undefined },
        localeClass                      : { type : Base, default : undefined },
        localizableProperties            : { type : Array, default : undefined },
        longPressTime                    : { type : Number, default : undefined },
        maintainSelectionOnDatasetChange : { type : Boolean, default : undefined },
        managedEventSizing               : { type : Boolean, default : undefined },
        maskDefaults                     : { type : [Object, Mask], default : undefined },
        masked                           : { type : [Boolean, String, Object, Mask], default : undefined },
        maximizable                      : { type : Boolean, default : undefined },
        maximized                        : { type : Boolean, default : undefined },
        milestoneCharWidth               : { type : Number, default : undefined },
        milestoneLayoutMode              : { type : String, default : undefined },
        milestoneTextPosition            : { type : String, default : undefined },
        modal                            : { type : Boolean, default : undefined },
        mode                             : { type : String, default : undefined },
        monitorResize                    : { type : Boolean, default : undefined },
        mouseOffsetX                     : { type : Number, default : undefined },
        mouseOffsetY                     : { type : Number, default : undefined },
        multiEventSelect                 : { type : Boolean, default : undefined },
        namedItems                       : { type : Object, default : undefined },
        owner                            : { type : Widget, default : undefined },
        partner                          : { type : TimelineBase, default : undefined },
        passStartEndParameters           : { type : Boolean, default : undefined },
        plugins                          : { type : Array, default : undefined },
        positioned                       : { type : Boolean, default : undefined },
        preCalculateHeightLimit          : { type : Number, default : undefined },
        preserveFocusOnDatasetChange     : { type : Boolean, default : undefined },
        preserveScrollOnDatasetChange    : { type : Boolean, default : undefined },
        preventTooltipOnTouch            : { type : Boolean, default : undefined },
        range                            : { type : String, default : undefined },
        removeUnassignedEvent            : { type : Boolean, default : undefined },
        resizeToFitIncludesHeader        : { type : Boolean, default : undefined },
        resourceColumns                  : { type : Object, default : undefined },
        resourceImageExtension           : { type : String, default : undefined },
        resourceImagePath                : { type : String, default : undefined },
        responsiveLevels                 : { type : Object, default : undefined },
        ripple                           : { type : [Boolean, Object], default : undefined },
        rootElement                      : { type : ShadowRoot, default : undefined },
        scrollAction                     : { type : String, default : undefined },
        scrollerClass                    : { type : Scroller, default : undefined },
        scrollManager                    : { type : [Object, ScrollManager], default : undefined },
        selectionMode                    : { type : Object, default : undefined },
        showAnimation                    : { type : [Boolean, Object], default : undefined },
        showCreationTooltip              : { type : Boolean, default : undefined },
        showDirty                        : { type : Boolean, default : undefined },
        showOnClick                      : { type : Boolean, default : undefined },
        showOnHover                      : { type : Boolean, default : undefined },
        showRecurringUI                  : { type : Boolean, default : undefined },
        showRemoveRowInContextMenu       : { type : Boolean, default : undefined },
        snapRelativeToEventStartDate     : { type : Boolean, default : undefined },
        startParamName                   : { type : String, default : undefined },
        stepUnit                         : { type : String, default : undefined },
        stickyHeaders                    : { type : Boolean, default : undefined },
        strips                           : { type : Object, default : undefined },
        subGridConfigs                   : { type : Object, default : undefined },
        suppressFit                      : { type : Boolean, default : undefined },
        syncMask                         : { type : [String, Object, null], default : undefined },
        tab                              : { type : [Boolean, Object], default : undefined },
        tag                              : { type : String, default : undefined },
        tbar                             : { type : [Array, Object], default : undefined },
        terminalCls                      : { type : String, default : undefined },
        terminalSides                    : { type : Array, default : undefined },
        textAlign                        : { type : String, default : undefined },
        textContent                      : { type : Boolean, default : undefined },
        timeAxis                         : { type : [Object, TimeAxis], default : undefined },
        title                            : { type : String, default : undefined },
        trapFocus                        : { type : Boolean, default : undefined },
        triggerSelectionChangeOnRemove   : { type : Boolean, default : undefined },
        verticalTimeAxisColumn           : { type : Object, default : undefined },
        visibleDate                      : { type : [Date, Object], default : undefined },
        visibleZoomFactor                : { type : Number, default : undefined },
        weekStartDay                     : { type : Number, default : undefined },
        weight                           : { type : Number, default : undefined },
        zoomKeepsOriginalTimespan        : { type : Boolean, default : undefined },
        zoomOnMouseWheel                 : { type : Boolean, default : undefined },
        zoomOnTimeAxisDoubleClick        : { type : Boolean, default : undefined },

         // Configs and properties
        alignSelf              : { type : String, default : undefined },
        allowDropOnEventBar    : { type : Boolean, default : undefined },
        assignments            : { type : Array, default : undefined },
        assignmentStore        : { type : [AssignmentStore, Object], default : undefined },
        barMargin              : { type : Number, default : undefined },
        columnLines            : { type : Boolean, default : undefined },
        content                : { type : String, default : undefined },
        crudManager            : { type : [CrudManager, Object], default : undefined },
        data                   : { type : Array, default : undefined },
        dataset                : { type : Object, default : undefined },
        dependencies           : { type : Array, default : undefined },
        dependencyStore        : { type : [DependencyStore, Object], default : undefined },
        disabled               : { type : Boolean, default : undefined },
        displayDateFormat      : { type : String, default : undefined },
        endDate                : { type : [Date, String], default : undefined },
        eventLayout            : { type : String, default : undefined },
        events                 : { type : Array, default : undefined },
        eventStore             : { type : [EventStore, Object], default : undefined },
        extraData              : { type : [String, Number, Boolean, Object], default : undefined },
        fillTicks              : { type : [String, Boolean], default : undefined },
        flex                   : { type : [Number, String], default : undefined },
        height                 : { type : [Number, String], default : undefined },
        hidden                 : { type : Boolean, default : undefined },
        html                   : { type : String, default : undefined },
        id                     : { type : String, default : undefined },
        items                  : { type : [Array, Object], default : undefined },
        layout                 : { type : [Layout, String], default : undefined },
        layoutStyle            : { type : Object, default : undefined },
        margin                 : { type : [Number, String], default : undefined },
        maxHeight              : { type : [String, Number], default : undefined },
        maxWidth               : { type : [String, Number], default : undefined },
        maxZoomLevel           : { type : Number, default : undefined },
        milestoneAlign         : { type : String, default : undefined },
        minHeight              : { type : [String, Number], default : undefined },
        minWidth               : { type : [String, Number], default : undefined },
        minZoomLevel           : { type : Number, default : undefined },
        presets                : { type : [PresetStore, Array], default : undefined },
        project                : { type : [ProjectModel, Object], default : undefined },
        readOnly               : { type : Boolean, default : undefined },
        resourceMargin         : { type : Number, default : undefined },
        resources              : { type : Array, default : undefined },
        resourceStore          : { type : [ResourceStore, Object], default : undefined },
        resourceTimeRanges     : { type : Array, default : undefined },
        resourceTimeRangeStore : { type : [ResourceTimeRangeStore, Object], default : undefined },
        rowHeight              : { type : Number, default : undefined },
        scrollable             : { type : [Scroller, Boolean, Object], default : undefined },
        snap                   : { type : Boolean, default : undefined },
        startDate              : { type : [Date, String], default : undefined },
        store                  : { type : [Store, Object], default : undefined },
        tickSize               : { type : Number, default : undefined },
        timeRanges             : { type : Array, default : undefined },
        timeRangeStore         : { type : [Store, Object], default : undefined },
        tools                  : { type : Object, default : undefined },
        tooltip                : { type : [String, Object], default : undefined },
        transitionDuration     : { type : Number, default : undefined },
        useInitialAnimation    : { type : [Boolean, String], default : undefined },
        viewPreset             : { type : [ViewPreset, String, Object], default : undefined },
        width                  : { type : [Number, String], default : undefined },
        workingTime            : { type : Object, default : undefined },
        x                      : { type : Number, default : undefined },
        y                      : { type : Number, default : undefined },

         // Properties only
        anchorSize          : { type : Array, default : undefined },
        eventColors         : { type : Array, default : undefined },
        eventStyles         : { type : Array, default : undefined },
        isEngineReady       : { type : Boolean, default : undefined },
        isSettingValues     : { type : Boolean, default : undefined },
        isValid             : { type : Boolean, default : undefined },
        record              : { type : Model, default : undefined },
        scrollLeft          : { type : Number, default : undefined },
        scrollTop           : { type : Number, default : undefined },
        selectedAssignments : { type : Array, default : undefined },
        selectedCell        : { type : Object, default : undefined },
        selectedEvents      : { type : Array, default : undefined },
        selectedRecord      : { type : Model, default : undefined },
        selectedRecords     : { type : Array, default : undefined },
        state               : { type : Object, default : undefined },
        timeResolution      : { type : [Object, Number], default : undefined },
        values              : { type : Object, default : undefined },
        zoomLevel           : { type : Number, default : undefined },

         // Events
        onAfterDependencyCreateDrop           : { type : Function, default : undefined },
        onAfterDependencySave                 : { type : Function, default : undefined },
        onAfterDragCreate                     : { type : Function, default : undefined },
        onAfterEventDrop                      : { type : Function, default : undefined },
        onAfterEventSave                      : { type : Function, default : undefined },
        onAssignmentSelectionChange           : { type : Function, default : undefined },
        onBeforeAssignmentDelete              : { type : Function, default : undefined },
        onBeforeCellEditStart                 : { type : Function, default : undefined },
        onBeforeDependencyAdd                 : { type : Function, default : undefined },
        onBeforeDependencyCreateDrag          : { type : Function, default : undefined },
        onBeforeDependencyCreateFinalize      : { type : Function, default : undefined },
        onBeforeDependencyDelete              : { type : Function, default : undefined },
        onBeforeDependencyEdit                : { type : Function, default : undefined },
        onBeforeDependencyEditShow            : { type : Function, default : undefined },
        onBeforeDependencySave                : { type : Function, default : undefined },
        onBeforeDestroy                       : { type : Function, default : undefined },
        onBeforeDragCreate                    : { type : Function, default : undefined },
        onBeforeDragCreateFinalize            : { type : Function, default : undefined },
        onBeforeEventAdd                      : { type : Function, default : undefined },
        onBeforeEventDelete                   : { type : Function, default : undefined },
        onBeforeEventDrag                     : { type : Function, default : undefined },
        onBeforeEventDropFinalize             : { type : Function, default : undefined },
        onBeforeEventEdit                     : { type : Function, default : undefined },
        onBeforeEventEditShow                 : { type : Function, default : undefined },
        onBeforeEventResize                   : { type : Function, default : undefined },
        onBeforeEventResizeFinalize           : { type : Function, default : undefined },
        onBeforeEventSave                     : { type : Function, default : undefined },
        onBeforeExport                        : { type : Function, default : undefined },
        onBeforeFinishCellEdit                : { type : Function, default : undefined },
        onBeforeHide                          : { type : Function, default : undefined },
        onBeforePresetChange                  : { type : Function, default : undefined },
        onBeforeRenderRows                    : { type : Function, default : undefined },
        onBeforeSetRecord                     : { type : Function, default : undefined },
        onBeforeShow                          : { type : Function, default : undefined },
        onBeforeToggleNode                    : { type : Function, default : undefined },
        onCancelCellEdit                      : { type : Function, default : undefined },
        onCatchAll                            : { type : Function, default : undefined },
        onCellClick                           : { type : Function, default : undefined },
        onCellContextMenu                     : { type : Function, default : undefined },
        onCellContextMenuBeforeShow           : { type : Function, default : undefined },
        onCellContextMenuShow                 : { type : Function, default : undefined },
        onCellDblClick                        : { type : Function, default : undefined },
        onCellMenuBeforeShow                  : { type : Function, default : undefined },
        onCellMenuItem                        : { type : Function, default : undefined },
        onCellMenuShow                        : { type : Function, default : undefined },
        onCellMenuToggleItem                  : { type : Function, default : undefined },
        onCellMouseOut                        : { type : Function, default : undefined },
        onCellMouseOver                       : { type : Function, default : undefined },
        onCollapseNode                        : { type : Function, default : undefined },
        onContextMenuItem                     : { type : Function, default : undefined },
        onContextMenuToggleItem               : { type : Function, default : undefined },
        onDataChange                          : { type : Function, default : undefined },
        onDependencyClick                     : { type : Function, default : undefined },
        onDependencyCreateDragStart           : { type : Function, default : undefined },
        onDependencyCreateDrop                : { type : Function, default : undefined },
        onDependencyDblClick                  : { type : Function, default : undefined },
        onDependencyMouseOut                  : { type : Function, default : undefined },
        onDependencyMouseOver                 : { type : Function, default : undefined },
        onDependencyValidationComplete        : { type : Function, default : undefined },
        onDependencyValidationStart           : { type : Function, default : undefined },
        onDestroy                             : { type : Function, default : undefined },
        onDragCreateEnd                       : { type : Function, default : undefined },
        onDragCreateStart                     : { type : Function, default : undefined },
        onEventClick                          : { type : Function, default : undefined },
        onEventContextMenu                    : { type : Function, default : undefined },
        onEventDblClick                       : { type : Function, default : undefined },
        onEventDrag                           : { type : Function, default : undefined },
        onEventDragAbort                      : { type : Function, default : undefined },
        onEventDragStart                      : { type : Function, default : undefined },
        onEventDrop                           : { type : Function, default : undefined },
        onEventEditBeforeSetRecord            : { type : Function, default : undefined },
        onEventKeyDown                        : { type : Function, default : undefined },
        onEventKeyUp                          : { type : Function, default : undefined },
        onEventMenuBeforeShow                 : { type : Function, default : undefined },
        onEventMenuItem                       : { type : Function, default : undefined },
        onEventMenuShow                       : { type : Function, default : undefined },
        onEventMouseDown                      : { type : Function, default : undefined },
        onEventMouseOut                       : { type : Function, default : undefined },
        onEventMouseOver                      : { type : Function, default : undefined },
        onEventMouseUp                        : { type : Function, default : undefined },
        onEventPartialResize                  : { type : Function, default : undefined },
        onEventResizeEnd                      : { type : Function, default : undefined },
        onEventResizeStart                    : { type : Function, default : undefined },
        onEventSelectionChange                : { type : Function, default : undefined },
        onExpandNode                          : { type : Function, default : undefined },
        onExport                              : { type : Function, default : undefined },
        onFinishCellEdit                      : { type : Function, default : undefined },
        onFocusIn                             : { type : Function, default : undefined },
        onFocusOut                            : { type : Function, default : undefined },
        onHeaderContextMenuBeforeShow         : { type : Function, default : undefined },
        onHeaderContextMenuShow               : { type : Function, default : undefined },
        onHeaderMenuBeforeShow                : { type : Function, default : undefined },
        onHeaderMenuItem                      : { type : Function, default : undefined },
        onHeaderMenuShow                      : { type : Function, default : undefined },
        onHeaderMenuToggleItem                : { type : Function, default : undefined },
        onHide                                : { type : Function, default : undefined },
        onMouseOut                            : { type : Function, default : undefined },
        onMouseOver                           : { type : Function, default : undefined },
        onNavigate                            : { type : Function, default : undefined },
        onPaint                               : { type : Function, default : undefined },
        onPresetChange                        : { type : Function, default : undefined },
        onReadOnly                            : { type : Function, default : undefined },
        onReleaseEvent                        : { type : Function, default : undefined },
        onRenderEvent                         : { type : Function, default : undefined },
        onRenderRows                          : { type : Function, default : undefined },
        onResize                              : { type : Function, default : undefined },
        onResourceHeaderClick                 : { type : Function, default : undefined },
        onResourceHeaderContextmenu           : { type : Function, default : undefined },
        onResourceHeaderDblclick              : { type : Function, default : undefined },
        onResponsive                          : { type : Function, default : undefined },
        onScheduleClick                       : { type : Function, default : undefined },
        onScheduleContextMenu                 : { type : Function, default : undefined },
        onScheduleDblClick                    : { type : Function, default : undefined },
        onScheduleMenuBeforeShow              : { type : Function, default : undefined },
        onScheduleMenuItem                    : { type : Function, default : undefined },
        onScheduleMenuShow                    : { type : Function, default : undefined },
        onScheduleMouseMove                   : { type : Function, default : undefined },
        onScroll                              : { type : Function, default : undefined },
        onSelectionChange                     : { type : Function, default : undefined },
        onShow                                : { type : Function, default : undefined },
        onStartCellEdit                       : { type : Function, default : undefined },
        onTimeAxisChange                      : { type : Function, default : undefined },
        onTimeAxisHeaderClick                 : { type : Function, default : undefined },
        onTimeAxisHeaderContextMenu           : { type : Function, default : undefined },
        onTimeAxisHeaderContextMenuBeforeShow : { type : Function, default : undefined },
        onTimeAxisHeaderContextMenuItem       : { type : Function, default : undefined },
        onTimeAxisHeaderContextMenuShow       : { type : Function, default : undefined },
        onTimeAxisHeaderDblClick              : { type : Function, default : undefined },
        onTimelineViewportResize              : { type : Function, default : undefined },
        onToggleNode                          : { type : Function, default : undefined },
        onToolClick                           : { type : Function, default : undefined },

         // Features
        cellEditFeature     : { type : [Object, Boolean, String], default : undefined },
        cellMenuFeature     : { type : [Object, Boolean, String], default : undefined },
        cellTooltipFeature  : { type : [Object, Boolean, String], default : undefined },
        columnAutoWidthFeature : { type : [Object, Boolean, String], default : undefined },
        columnDragToolbarFeature : { type : [Object, Boolean, String], default : undefined },
        columnLinesFeature  : { type : [Object, Boolean, String], default : undefined },
        columnPickerFeature : { type : [Object, Boolean, String], default : undefined },
        columnReorderFeature : { type : [Object, Boolean, String], default : undefined },
        columnResizeFeature : { type : [Object, Boolean, String], default : undefined },
        contextMenuFeature  : { type : [Object, Boolean, String], default : undefined },
        dependenciesFeature : { type : [Object, Boolean, String], default : undefined },
        dependencyEditFeature : { type : [Object, Boolean, String], default : undefined },
        eventContextMenuFeature : { type : [Object, Boolean, String], default : undefined },
        eventCopyPasteFeature : { type : [Object, Boolean, String], default : undefined },
        eventDragFeature    : { type : [Object, Boolean, String], default : undefined },
        eventDragCreateFeature : { type : [Object, Boolean, String], default : undefined },
        eventDragSelectFeature : { type : [Object, Boolean, String], default : undefined },
        eventEditFeature    : { type : [Object, Boolean, String], default : undefined },
        eventFilterFeature  : { type : [Object, Boolean, String], default : undefined },
        eventMenuFeature    : { type : [Object, Boolean, String], default : undefined },
        eventResizeFeature  : { type : [Object, Boolean, String], default : undefined },
        eventTooltipFeature : { type : [Object, Boolean, String], default : undefined },
        excelExporterFeature : { type : [Object, Boolean, String], default : undefined },
        filterFeature       : { type : [Object, Boolean, String], default : undefined },
        filterBarFeature    : { type : [Object, Boolean, String], default : undefined },
        groupFeature        : { type : [Object, Boolean, String], default : undefined },
        groupSummaryFeature : { type : [Object, Boolean, String], default : undefined },
        headerContextMenuFeature : { type : [Object, Boolean, String], default : undefined },
        headerMenuFeature   : { type : [Object, Boolean, String], default : undefined },
        headerZoomFeature   : { type : [Object, Boolean, String], default : undefined },
        labelsFeature       : { type : [Object, Boolean, String], default : undefined },
        nonWorkingTimeFeature : { type : [Object, Boolean, String], default : undefined },
        panFeature          : { type : [Object, Boolean, String], default : undefined },
        pdfExportFeature    : { type : [Object, Boolean, String], default : undefined },
        quickFindFeature    : { type : [Object, Boolean, String], default : undefined },
        regionResizeFeature : { type : [Object, Boolean, String], default : undefined },
        resourceTimeRangesFeature : { type : [Object, Boolean, String], default : undefined },
        rowCopyPasteFeature : { type : [Object, Boolean, String], default : undefined },
        rowReorderFeature   : { type : [Object, Boolean, String], default : undefined },
        scheduleContextFeature : { type : [Object, Boolean, String], default : undefined },
        scheduleContextMenuFeature : { type : [Object, Boolean, String], default : undefined },
        scheduleMenuFeature : { type : [Object, Boolean, String], default : undefined },
        scheduleTooltipFeature : { type : [Object, Boolean, String], default : undefined },
        searchFeature       : { type : [Object, Boolean, String], default : undefined },
        simpleEventEditFeature : { type : [Object, Boolean, String], default : undefined },
        sortFeature         : { type : [Object, Boolean, String], default : undefined },
        stickyCellsFeature  : { type : [Object, Boolean, String], default : undefined },
        stickyEventsFeature : { type : [Object, Boolean, String], default : undefined },
        stripeFeature       : { type : [Object, Boolean, String], default : undefined },
        summaryFeature      : { type : [Object, Boolean, String], default : undefined },
        timeAxisHeaderMenuFeature : { type : [Object, Boolean, String], default : undefined },
        timeRangesFeature   : { type : [Object, Boolean, String], default : undefined },
        treeFeature         : { type : [Object, Boolean, String], default : undefined },

    },

    data : () => {
        return {
            instanceClass : Scheduler,

            isView : true,

            cellInstances : [],

            dataStores : {"assignmentStore":"assignments","dependencyStore":"dependencies","eventStore":"events","resourceStore":"resources","resourceTimeRangeStore":"resourceTimeRanges","timeRangeStore":"timeRanges"},

            featureNames : [
                'cellEditFeature',
                'cellMenuFeature',
                'cellTooltipFeature',
                'columnAutoWidthFeature',
                'columnDragToolbarFeature',
                'columnLinesFeature',
                'columnPickerFeature',
                'columnReorderFeature',
                'columnResizeFeature',
                'contextMenuFeature',
                'dependenciesFeature',
                'dependencyEditFeature',
                'eventContextMenuFeature',
                'eventCopyPasteFeature',
                'eventDragFeature',
                'eventDragCreateFeature',
                'eventDragSelectFeature',
                'eventEditFeature',
                'eventFilterFeature',
                'eventMenuFeature',
                'eventResizeFeature',
                'eventTooltipFeature',
                'excelExporterFeature',
                'filterFeature',
                'filterBarFeature',
                'groupFeature',
                'groupSummaryFeature',
                'headerContextMenuFeature',
                'headerMenuFeature',
                'headerZoomFeature',
                'labelsFeature',
                'nonWorkingTimeFeature',
                'panFeature',
                'pdfExportFeature',
                'quickFindFeature',
                'regionResizeFeature',
                'resourceTimeRangesFeature',
                'rowCopyPasteFeature',
                'rowReorderFeature',
                'scheduleContextFeature',
                'scheduleContextMenuFeature',
                'scheduleMenuFeature',
                'scheduleTooltipFeature',
                'searchFeature',
                'simpleEventEditFeature',
                'sortFeature',
                'stickyCellsFeature',
                'stickyEventsFeature',
                'stripeFeature',
                'summaryFeature',
                'timeAxisHeaderMenuFeature',
                'timeRangesFeature',
                'treeFeature'
            ],

            configNames : [
                'adopt',
                'align',
                'allowCreate',
                'allowOver',
                'allowOverlap',
                'anchor',
                'anchorToTarget',
                'animateRemovingRows',
                'appendTo',
                'autoAdjustTimeAxis',
                'autoClose',
                'autoHeight',
                'autoShow',
                'bbar',
                'bodyCls',
                'bubbleEvents',
                'bufferCoef',
                'bufferThreshold',
                'centered',
                'closable',
                'closeAction',
                'cls',
                'columns',
                'config',
                'constrainTo',
                'contentElementCls',
                'contextMenuTriggerEvent',
                'createEventOnDblClick',
                'creationTooltip',
                'crudManagerClass',
                'date',
                'defaultBindProperty',
                'defaultRegion',
                'defaultResourceImageName',
                'defaults',
                'descriptionRenderer',
                'destroyStore',
                'destroyStores',
                'disableGridRowModelWarning',
                'dismissDelay',
                'dock',
                'draggable',
                'durationDisplayPrecision',
                'emptyText',
                'enableDeleteKey',
                'enableEventAnimations',
                'enableRecurringEvents',
                'enableSticky',
                'enableTextSelection',
                'enableUndoRedoKeys',
                'endParamName',
                'eventBarTextField',
                'eventBodyTemplate',
                'eventColor',
                'eventRenderer',
                'eventRendererThisObj',
                'eventSelectionDisabled',
                'eventStyle',
                'features',
                'fillLastColumn',
                'fixedRowHeight',
                'floating',
                'focusOnToFront',
                'footer',
                'forceFit',
                'forElement',
                'forSelector',
                'fullRowRefresh',
                'getDateConstraints',
                'getHtml',
                'getRowHeight',
                'header',
                'hideAnimation',
                'hideDelay',
                'hideHeaders',
                'hideOnDelegateChange',
                'hideWhenEmpty',
                'highlightPredecessors',
                'highlightSuccessors',
                'horizontalEventSorterFn',
                'hoverDelay',
                'htmlCls',
                'infiniteScroll',
                'insertBefore',
                'insertFirst',
                'itemCls',
                'lazyItems',
                'listeners',
                'loadingMsg',
                'loadMask',
                'loadMaskDefaults',
                'loadMaskError',
                'localeClass',
                'localizableProperties',
                'longPressTime',
                'maintainSelectionOnDatasetChange',
                'managedEventSizing',
                'maskDefaults',
                'masked',
                'maximizable',
                'maximized',
                'milestoneCharWidth',
                'milestoneLayoutMode',
                'milestoneTextPosition',
                'modal',
                'mode',
                'monitorResize',
                'mouseOffsetX',
                'mouseOffsetY',
                'multiEventSelect',
                'namedItems',
                'owner',
                'partner',
                'passStartEndParameters',
                'plugins',
                'positioned',
                'preCalculateHeightLimit',
                'preserveFocusOnDatasetChange',
                'preserveScrollOnDatasetChange',
                'preventTooltipOnTouch',
                'range',
                'removeUnassignedEvent',
                'resizeToFitIncludesHeader',
                'resourceColumns',
                'resourceImageExtension',
                'resourceImagePath',
                'responsiveLevels',
                'ripple',
                'rootElement',
                'scrollAction',
                'scrollerClass',
                'scrollManager',
                'selectionMode',
                'showAnimation',
                'showCreationTooltip',
                'showDirty',
                'showOnClick',
                'showOnHover',
                'showRecurringUI',
                'showRemoveRowInContextMenu',
                'snapRelativeToEventStartDate',
                'startParamName',
                'stepUnit',
                'stickyHeaders',
                'strips',
                'subGridConfigs',
                'suppressFit',
                'syncMask',
                'tab',
                'tag',
                'tbar',
                'terminalCls',
                'terminalSides',
                'textAlign',
                'textContent',
                'timeAxis',
                'title',
                'trapFocus',
                'triggerSelectionChangeOnRemove',
                'verticalTimeAxisColumn',
                'visibleDate',
                'visibleZoomFactor',
                'weekStartDay',
                'weight',
                'zoomKeepsOriginalTimespan',
                'zoomOnMouseWheel',
                'zoomOnTimeAxisDoubleClick'
            ],

            propertyConfigNames : [
                'alignSelf',
                'allowDropOnEventBar',
                'assignments',
                'assignmentStore',
                'barMargin',
                'columnLines',
                'content',
                'crudManager',
                'data',
                'dataset',
                'dependencies',
                'dependencyStore',
                'disabled',
                'displayDateFormat',
                'endDate',
                'eventLayout',
                'events',
                'eventStore',
                'extraData',
                'fillTicks',
                'flex',
                'height',
                'hidden',
                'html',
                'id',
                'items',
                'layout',
                'layoutStyle',
                'margin',
                'maxHeight',
                'maxWidth',
                'maxZoomLevel',
                'milestoneAlign',
                'minHeight',
                'minWidth',
                'minZoomLevel',
                'onAfterDependencyCreateDrop',
                'onAfterDependencySave',
                'onAfterDragCreate',
                'onAfterEventDrop',
                'onAfterEventSave',
                'onAssignmentSelectionChange',
                'onBeforeAssignmentDelete',
                'onBeforeCellEditStart',
                'onBeforeDependencyAdd',
                'onBeforeDependencyCreateDrag',
                'onBeforeDependencyCreateFinalize',
                'onBeforeDependencyDelete',
                'onBeforeDependencyEdit',
                'onBeforeDependencyEditShow',
                'onBeforeDependencySave',
                'onBeforeDestroy',
                'onBeforeDragCreate',
                'onBeforeDragCreateFinalize',
                'onBeforeEventAdd',
                'onBeforeEventDelete',
                'onBeforeEventDrag',
                'onBeforeEventDropFinalize',
                'onBeforeEventEdit',
                'onBeforeEventEditShow',
                'onBeforeEventResize',
                'onBeforeEventResizeFinalize',
                'onBeforeEventSave',
                'onBeforeExport',
                'onBeforeFinishCellEdit',
                'onBeforeHide',
                'onBeforePresetChange',
                'onBeforeRenderRows',
                'onBeforeSetRecord',
                'onBeforeShow',
                'onBeforeToggleNode',
                'onCancelCellEdit',
                'onCatchAll',
                'onCellClick',
                'onCellContextMenu',
                'onCellContextMenuBeforeShow',
                'onCellContextMenuShow',
                'onCellDblClick',
                'onCellMenuBeforeShow',
                'onCellMenuItem',
                'onCellMenuShow',
                'onCellMenuToggleItem',
                'onCellMouseOut',
                'onCellMouseOver',
                'onCollapseNode',
                'onContextMenuItem',
                'onContextMenuToggleItem',
                'onDataChange',
                'onDependencyClick',
                'onDependencyCreateDragStart',
                'onDependencyCreateDrop',
                'onDependencyDblClick',
                'onDependencyMouseOut',
                'onDependencyMouseOver',
                'onDependencyValidationComplete',
                'onDependencyValidationStart',
                'onDestroy',
                'onDragCreateEnd',
                'onDragCreateStart',
                'onEventClick',
                'onEventContextMenu',
                'onEventDblClick',
                'onEventDrag',
                'onEventDragAbort',
                'onEventDragStart',
                'onEventDrop',
                'onEventEditBeforeSetRecord',
                'onEventKeyDown',
                'onEventKeyUp',
                'onEventMenuBeforeShow',
                'onEventMenuItem',
                'onEventMenuShow',
                'onEventMouseDown',
                'onEventMouseOut',
                'onEventMouseOver',
                'onEventMouseUp',
                'onEventPartialResize',
                'onEventResizeEnd',
                'onEventResizeStart',
                'onEventSelectionChange',
                'onExpandNode',
                'onExport',
                'onFinishCellEdit',
                'onFocusIn',
                'onFocusOut',
                'onHeaderContextMenuBeforeShow',
                'onHeaderContextMenuShow',
                'onHeaderMenuBeforeShow',
                'onHeaderMenuItem',
                'onHeaderMenuShow',
                'onHeaderMenuToggleItem',
                'onHide',
                'onMouseOut',
                'onMouseOver',
                'onNavigate',
                'onPaint',
                'onPresetChange',
                'onReadOnly',
                'onReleaseEvent',
                'onRenderEvent',
                'onRenderRows',
                'onResize',
                'onResourceHeaderClick',
                'onResourceHeaderContextmenu',
                'onResourceHeaderDblclick',
                'onResponsive',
                'onScheduleClick',
                'onScheduleContextMenu',
                'onScheduleDblClick',
                'onScheduleMenuBeforeShow',
                'onScheduleMenuItem',
                'onScheduleMenuShow',
                'onScheduleMouseMove',
                'onScroll',
                'onSelectionChange',
                'onShow',
                'onStartCellEdit',
                'onTimeAxisChange',
                'onTimeAxisHeaderClick',
                'onTimeAxisHeaderContextMenu',
                'onTimeAxisHeaderContextMenuBeforeShow',
                'onTimeAxisHeaderContextMenuItem',
                'onTimeAxisHeaderContextMenuShow',
                'onTimeAxisHeaderDblClick',
                'onTimelineViewportResize',
                'onToggleNode',
                'onToolClick',
                'presets',
                'project',
                'readOnly',
                'resourceMargin',
                'resources',
                'resourceStore',
                'resourceTimeRanges',
                'resourceTimeRangeStore',
                'rowHeight',
                'scrollable',
                'snap',
                'startDate',
                'store',
                'tickSize',
                'timeRanges',
                'timeRangeStore',
                'tools',
                'tooltip',
                'transitionDuration',
                'useInitialAnimation',
                'viewPreset',
                'width',
                'workingTime',
                'x',
                'y'
            ],

            propertyNames : [
                'anchorSize',
                'eventColors',
                'eventStyles',
                'isEngineReady',
                'isSettingValues',
                'isValid',
                'record',
                'scrollLeft',
                'scrollTop',
                'selectedAssignments',
                'selectedCell',
                'selectedEvents',
                'selectedRecord',
                'selectedRecords',
                'state',
                'timeResolution',
                'values',
                'zoomLevel'
            ],

            eventNames : [
                'afterDependencyCreateDrop',
                'afterDependencySave',
                'afterDragCreate',
                'afterEventDrop',
                'afterEventSave',
                'assignmentSelectionChange',
                'beforeAssignmentDelete',
                'beforeCellEditStart',
                'beforeDependencyAdd',
                'beforeDependencyCreateDrag',
                'beforeDependencyCreateFinalize',
                'beforeDependencyDelete',
                'beforeDependencyEdit',
                'beforeDependencyEditShow',
                'beforeDependencySave',
                'beforeDestroy',
                'beforeDragCreate',
                'beforeDragCreateFinalize',
                'beforeEventAdd',
                'beforeEventDelete',
                'beforeEventDrag',
                'beforeEventDropFinalize',
                'beforeEventEdit',
                'beforeEventEditShow',
                'beforeEventResize',
                'beforeEventResizeFinalize',
                'beforeEventSave',
                'beforeExport',
                'beforeFinishCellEdit',
                'beforeHide',
                'beforePresetChange',
                'beforeRenderRows',
                'beforeSetRecord',
                'beforeShow',
                'beforeToggleNode',
                'cancelCellEdit',
                'catchAll',
                'cellClick',
                'cellContextMenu',
                'cellContextMenuBeforeShow',
                'cellContextMenuShow',
                'cellDblClick',
                'cellMenuBeforeShow',
                'cellMenuItem',
                'cellMenuShow',
                'cellMenuToggleItem',
                'cellMouseOut',
                'cellMouseOver',
                'collapseNode',
                'contextMenuItem',
                'contextMenuToggleItem',
                'dataChange',
                'dependencyClick',
                'dependencyCreateDragStart',
                'dependencyCreateDrop',
                'dependencyDblClick',
                'dependencyMouseOut',
                'dependencyMouseOver',
                'dependencyValidationComplete',
                'dependencyValidationStart',
                'destroy',
                'dragCreateEnd',
                'dragCreateStart',
                'eventClick',
                'eventContextMenu',
                'eventDblClick',
                'eventDrag',
                'eventDragAbort',
                'eventDragStart',
                'eventDrop',
                'eventEditBeforeSetRecord',
                'eventKeyDown',
                'eventKeyUp',
                'eventMenuBeforeShow',
                'eventMenuItem',
                'eventMenuShow',
                'eventMouseDown',
                'eventMouseOut',
                'eventMouseOver',
                'eventMouseUp',
                'eventPartialResize',
                'eventResizeEnd',
                'eventResizeStart',
                'eventSelectionChange',
                'expandNode',
                'export',
                'finishCellEdit',
                'focusIn',
                'focusOut',
                'headerContextMenuBeforeShow',
                'headerContextMenuShow',
                'headerMenuBeforeShow',
                'headerMenuItem',
                'headerMenuShow',
                'headerMenuToggleItem',
                'hide',
                'mouseOut',
                'mouseOver',
                'navigate',
                'paint',
                'presetChange',
                'releaseEvent',
                'renderEvent',
                'renderRows',
                'resize',
                'resourceHeaderClick',
                'resourceHeaderContextmenu',
                'resourceHeaderDblclick',
                'responsive',
                'scheduleClick',
                'scheduleContextMenu',
                'scheduleDblClick',
                'scheduleMenuBeforeShow',
                'scheduleMenuItem',
                'scheduleMenuShow',
                'scheduleMouseMove',
                'scroll',
                'selectionChange',
                'show',
                'startCellEdit',
                'timeAxisChange',
                'timeAxisHeaderClick',
                'timeAxisHeaderContextMenu',
                'timeAxisHeaderContextMenuBeforeShow',
                'timeAxisHeaderContextMenuItem',
                'timeAxisHeaderContextMenuShow',
                'timeAxisHeaderDblClick',
                'timelineViewportResize',
                'toggleNode',
                'toolClick'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps
            }  = WrapperHelper(),
            {
                processCellContent,
                hasFrameworkRenderer
            }  = WrapperHelperVue2();

        me.instance = createWidget({
            me,
            props                : me.$props,
            data                 : me.$data,
            listeners            : me.$listeners,
            emit                 : me.$emit.bind(me),
            element              : me.$el,
            processCellContent   : processCellContent.bind(me),
            hasFrameworkRenderer : hasFrameworkRenderer.bind(me)
        });
        // Backwards compatibility for gridInstance, schedulerInstance etc.
        me[StringHelper.uncapitalize(me.instanceClass.$name) + 'Instance'] = me.instance;
        relayStores(me.$data, me.instance);

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
